import API from "@/api"

export default {

    /**
     * 待办事项
     * @param {*} params 
     */
    async stat_all(params) {
        let data = await API.RES.Stat(params)
        this.res.stat.all = data || []
    },
}